<template>
  <v-card elevation="0" class="pa-4 summary-card w-100" rounded variant="flat" :color="getCardColor">
    <div class="d-flex justify-space-between align-center" style="gap: 8px;">
      <div>
        <v-icon class="text-primary--text" :color="getCardIconColor" size="small" :icon="getCardIcon" />
      </div>
      <div>
        <span class="d-block f-size-12 font-weight-bold" style="letter-spacing: 0px;">{{ getCardDescription }}</span>
        <span class="d-block f-size-12 summary-description" style="letter-spacing: 0px;">{{ getCardRemarks }}</span>
      </div>
    </div>

    <div class="d-flex flex-row align-center justify-end" style="gap: 8px;">
      <SummaryFeedback @click="bottomsUp" :icon="like ? 'mdi-thumb-up' : 'mdi-thumb-up-outline'" text="'Boa resposta'" :color="like ? 'primary' : 'gray'" />
      <SummaryFeedback @click="bottomsDown" :icon="deslike ? 'mdi-thumb-down' : 'mdi-thumb-down-outline'" text="'Resposta ruim'" :color="deslike ? 'azul-medium' : 'gray'" />
    </div>
  </v-card>
</template>

<script>
import { computed, ref } from 'vue';
import SummaryFeedback from './SummaryFeedback.vue';

export default {
  name: 'SummaryCard',
  components: {
    SummaryFeedback
  },
  props: {
    card: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    //TODO: botões para dar like/deslike no card do resumo - mockado por enquanto
    const like = ref(false);
    const deslike = ref(false);
  
    const theme = ref({
      color: "info",
      icon: "info"
    })

    const getCardDescription = computed(() => {
      return props?.card?.current_stage?.stage_name
    })

    const getCardRemarks = computed(() =>{
      return props?.card?.remarks
    })

    const getCardColor = computed(() => {
      if (props?.card?.status == "info") return "info"
      if (props?.card?.status == "alert") return "#E9DFAD"

      return "info"
    })

    const getCardIconColor = computed(() => {
      if (props?.card?.status == "info") return "primary"
      if (props?.card?.status == "alert") return "#96821D"

      return "primary"
    })

    const getCardIcon = computed(() => {
      if (props?.card?.status == "info") return "mdi-alert-circle-outline"
      if (props?.card?.status == "alert") return "mdi-alert-outline"

      return "mdi-alert-circle-outline"
    })

    const bottomsUp = () => {
      like.value = !like.value;

      if (like.value) deslike.value = false;
    };

    const bottomsDown = () => {
      deslike.value = !deslike.value;

      if (deslike.value) like.value = false;
    };

    return {
      theme,
      getCardDescription,
      getCardRemarks,
      getCardIconColor,
      getCardColor,
      getCardIcon,
      like,
      deslike,
      bottomsUp,
      bottomsDown
    }
  }
}
</script>

<style scoped>
.summary-card {
  border: 1px solid #F9F8FF;
  border-radius: 10px;
}

.summary-description {
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  white-space: normal;
}
</style>